<template><!-- <?xml version="1.0" encoding="iso-8859-1"?> -->
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M512,149.248c0-8.721-3.395-16.917-9.562-23.083L385.828,9.553C373.099-3.174,352.388-3.176,339.66,9.554l-0.979,0.979
			c-6.164,6.165-9.562,14.363-9.562,23.083c0,6.028,1.626,11.806,4.664,16.836c0.748,9.978,2.736,61.092-30.975,94.802
			L43.898,404.161c-7.163,7.164-10.065,16.972-8.777,26.31L1.808,476.779c-2.749,3.82-2.322,9.069,1.004,12.396l20.005,20.005
			c1.86,1.859,4.318,2.813,6.793,2.813c1.955,0,3.92-0.594,5.605-1.808l46.306-33.314c1.424,0.197,2.853,0.33,4.289,0.33
			c7.975,0,15.951-3.037,22.023-9.107L366.74,209.185c33.552-33.552,84.798-31.689,94.809-30.969
			c5.029,3.035,10.802,4.657,16.825,4.657c8.721,0,16.919-3.396,23.084-9.562l0.981-0.981h-0.001
			C508.605,166.165,512,157.967,512,149.248z M30.624,489.83l-8.462-8.463l22.97-31.929l17.422,17.422L30.624,489.83z
			 M353.16,195.605L94.251,454.514c-2.254,2.256-5.254,3.497-8.444,3.497c-3.189,0-6.188-1.242-8.443-3.497l-19.887-19.887
			c-4.656-4.656-4.656-12.232,0-16.887l258.909-258.909c27.666-27.666,35-64.075,36.567-87.857l88.063,88.063
			C417.234,160.604,380.827,167.94,353.16,195.605z M488.861,158.753l-0.982,0.981c-2.537,2.539-5.913,3.938-9.505,3.938
			c-3.591,0-6.965-1.398-9.504-3.938L352.258,43.122c-5.242-5.241-5.242-13.768,0.001-19.012l0.979-0.979
			c2.537-2.539,5.913-3.937,9.505-3.937c3.591,0,6.965,1.398,9.504,3.937l116.613,116.613c2.539,2.539,3.937,5.914,3.937,9.504
			C492.797,152.839,491.401,156.214,488.861,158.753z"/>
	</g>
</g>
<g>
	<g>
		<circle cx="120.272" cy="391.641" r="9.567"/>
	</g>
</g>
<g>
	<g>
		<circle cx="293.697" cy="218.23" r="9.567"/>
	</g>
</g>
<g>
	<g>
		<circle cx="250.337" cy="261.576" r="9.567"/>
	</g>
</g>
<g>
	<g>
		<circle cx="206.991" cy="304.936" r="9.567"/>
	</g>
</g>
<g>
	<g>
		<circle cx="163.631" cy="348.282" r="9.567"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>